export enum DefaultSearchTypeEnum {
    FAVORITES = 'favorites',
    NEWEST = 'newest',
    LAST_EDITED = 'last-edited'
}
